var _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 22,
    viewBox: "0 0 105 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.42189,
    cy: 5.37496,
    r: 4.7549,
    fill: "url(#paint0_linear)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7285,
    cy: 5.37496,
    r: 4.7549,
    transform: "rotate(90 17.7285 5.37496)",
    fill: "url(#paint1_linear)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.7285,
    cy: 17.1224,
    r: 4.7549,
    transform: "rotate(-180 17.7285 17.1224)",
    fill: "url(#paint2_linear)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.42165,
    cy: 17.1224,
    r: 4.7549,
    transform: "rotate(-90 5.42165 17.1224)",
    fill: "url(#paint3_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5599 18.7356C34.283 18.7356 33.1254 18.4612 32.0872 17.9122C31.0608 17.3513 30.2493 16.5816 29.6527 15.603C29.0679 14.6125 28.7755 13.4967 28.7755 12.2556C28.7755 11.0144 29.0679 9.90459 29.6527 8.92601C30.2493 7.9355 31.0608 7.16576 32.0872 6.61681C33.1254 6.05591 34.289 5.77547 35.5778 5.77547C36.6638 5.77547 37.6424 5.96641 38.5135 6.34829C39.3967 6.73018 40.1366 7.27914 40.7332 7.99517L38.8716 9.71364C38.0243 8.73507 36.9741 8.24578 35.721 8.24578C34.9453 8.24578 34.2532 8.41882 33.6445 8.7649C33.0359 9.09905 32.5585 9.57044 32.2125 10.1791C31.8783 10.7877 31.7112 11.4799 31.7112 12.2556C31.7112 13.0313 31.8783 13.7234 32.2125 14.332C32.5585 14.9407 33.0359 15.418 33.6445 15.7641C34.2532 16.0983 34.9453 16.2653 35.721 16.2653C36.9741 16.2653 38.0243 15.7701 38.8716 14.7796L40.7332 16.498C40.1366 17.226 39.3967 17.7809 38.5135 18.1628C37.6304 18.5447 36.6459 18.7356 35.5599 18.7356Z",
    fill: "#232E34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0944 18.5208L54.0765 11.0025L50.3889 17.1962H49.0821L45.4125 11.1636V18.5208H42.6916V5.99028H45.0903L49.7803 13.7771L54.3987 5.99028H56.7795L56.8153 18.5208H54.0944Z",
    fill: "#232E34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8566 18.7356C64.5558 18.7356 63.3803 18.4552 62.3301 17.8943C61.2919 17.3334 60.4744 16.5637 59.8777 15.5851C59.293 14.5946 59.0006 13.4847 59.0006 12.2556C59.0006 11.0264 59.293 9.92249 59.8777 8.94391C60.4744 7.9534 61.2919 7.1777 62.3301 6.61681C63.3803 6.05591 64.5558 5.77547 65.8566 5.77547C67.1574 5.77547 68.3269 6.05591 69.3652 6.61681C70.4034 7.1777 71.2209 7.9534 71.8176 8.94391C72.4143 9.92249 72.7126 11.0264 72.7126 12.2556C72.7126 13.4847 72.4143 14.5946 71.8176 15.5851C71.2209 16.5637 70.4034 17.3334 69.3652 17.8943C68.3269 18.4552 67.1574 18.7356 65.8566 18.7356ZM65.8566 16.2653C66.5965 16.2653 67.2648 16.0983 67.8615 15.7641C68.4582 15.418 68.9236 14.9407 69.2577 14.332C69.6038 13.7234 69.7769 13.0313 69.7769 12.2556C69.7769 11.4799 69.6038 10.7877 69.2577 10.1791C68.9236 9.57044 68.4582 9.09905 67.8615 8.7649C67.2648 8.41882 66.5965 8.24578 65.8566 8.24578C65.1167 8.24578 64.4484 8.41882 63.8517 8.7649C63.255 9.09905 62.7836 9.57044 62.4375 10.1791C62.1034 10.7877 61.9363 11.4799 61.9363 12.2556C61.9363 13.0313 62.1034 13.7234 62.4375 14.332C62.7836 14.9407 63.255 15.418 63.8517 15.7641C64.4484 16.0983 65.1167 16.2653 65.8566 16.2653Z",
    fill: "#232E34"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3407 2.748H77.3814V18.5208H75.3407V2.748Z",
    fill: "#232E34"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2777 7.25452H83.3184V18.5208H81.2777V7.25452ZM82.2981 5.08629C81.9013 5.08629 81.5682 4.95874 81.299 4.70366C81.0439 4.44857 80.9164 4.1368 80.9164 3.76834C80.9164 3.39988 81.0439 3.08811 81.299 2.83302C81.5682 2.56377 81.9013 2.42914 82.2981 2.42914C82.6949 2.42914 83.0208 2.55668 83.2759 2.81177C83.5452 3.05268 83.6798 3.35737 83.6798 3.72583C83.6798 4.10846 83.5452 4.4344 83.2759 4.70366C83.0208 4.95874 82.6949 5.08629 82.2981 5.08629Z",
    fill: "#232E34"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4459 18.6484C89.5247 18.6484 88.639 18.5279 87.7887 18.287C86.9385 18.0319 86.2724 17.7131 85.7906 17.3304L86.6409 15.7149C87.1369 16.0692 87.7391 16.3526 88.4477 16.5652C89.1563 16.7777 89.8719 16.884 90.5947 16.884C92.3803 16.884 93.2731 16.3739 93.2731 15.3535C93.2731 15.0134 93.1526 14.7441 92.9117 14.5457C92.6708 14.3473 92.3661 14.2056 91.9977 14.1206C91.6434 14.0214 91.1332 13.9151 90.4671 13.8017C89.5602 13.66 88.8162 13.4971 88.2351 13.3128C87.6683 13.1286 87.1794 12.8168 86.7684 12.3775C86.3574 11.9382 86.1519 11.3217 86.1519 10.5281C86.1519 9.50778 86.5771 8.69293 87.4274 8.08355C88.2777 7.46001 89.4185 7.14824 90.8498 7.14824C91.6009 7.14824 92.352 7.24035 93.103 7.42458C93.8541 7.60881 94.4706 7.85681 94.9524 8.16858L94.0809 9.78413C93.1597 9.18893 92.0756 8.89133 90.8285 8.89133C89.9641 8.89133 89.3051 9.03304 88.8516 9.31647C88.3981 9.5999 88.1714 9.97544 88.1714 10.4431C88.1714 10.8116 88.2989 11.1021 88.554 11.3146C88.8091 11.5272 89.1209 11.6831 89.4893 11.7823C89.8719 11.8815 90.4034 11.9949 91.0836 12.1224C91.9906 12.2783 92.7204 12.4484 93.2731 12.6326C93.84 12.8026 94.3218 13.1003 94.7186 13.5254C95.1154 13.9505 95.3138 14.5457 95.3138 15.311C95.3138 16.3313 94.8745 17.1462 93.9958 17.7556C93.1314 18.3508 91.9481 18.6484 90.4459 18.6484Z",
    fill: "#232E34"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.199 17.8619C103.901 18.1169 103.533 18.3154 103.093 18.4571C102.654 18.5846 102.201 18.6484 101.733 18.6484C100.599 18.6484 99.7206 18.3437 99.0971 17.7343C98.4735 17.1249 98.1618 16.2534 98.1618 15.1197V8.93384H96.2486V7.25452H98.1618V4.78869H100.202V7.25452H103.434V8.93384H100.202V15.0347C100.202 15.644 100.351 16.1117 100.649 16.4376C100.961 16.7636 101.4 16.9265 101.967 16.9265C102.59 16.9265 103.122 16.7494 103.561 16.3951L104.199 17.8619Z",
    fill: "#232E34"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 3.87284,
    y1: 2.70045,
    x2: 11.535,
    y2: 11.0592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2962FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2962FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16.1794,
    y1: 2.70045,
    x2: 23.8416,
    y2: 11.0592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2962FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2962FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 16.1794,
    y1: 14.4479,
    x2: 23.8416,
    y2: 22.8066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2962FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2962FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 3.8726,
    y1: 14.4479,
    x2: 11.5347,
    y2: 22.8066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2962FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2962FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1226f56f0daa1b41d4e01b47f51fd0eb.svg";
export { ForwardRef as ReactComponent };